export const SUPPORTED_DOCUMENT_EXTENSIONS = [
  ".docx",
  ".pptx",
  ".xlsx",
  ".pdf",
  ".md",
  ".txt",
  ".html",
] as const;

// Explicit extensions are intentional: native Windows file pickers do not
// consistently translate MIME-only accept values, which forced users to pick
// "All Files" before supported documents became visible.
export const DOCUMENT_UPLOAD_ACCEPT = SUPPORTED_DOCUMENT_EXTENSIONS.join(",");

// Playground also supports image attachments; its document formats stay in
// sync with Document Collections through the shared list above.
export const PLAYGROUND_UPLOAD_ACCEPT = [
  "image/*",
  ...SUPPORTED_DOCUMENT_EXTENSIONS,
].join(",");
